module.exports = __webpack_public_path__ + "img/engine-green.bf497c92.png";